/*!
 * jQuery doTimeout: Like setTimeout, but better! - v1.0 - 3/3/2010
 * http://benalman.com/projects/jquery-dotimeout-plugin/
 * 
 * Copyright (c) 2010 "Cowboy" Ben Alman
 * Dual licensed under the MIT and GPL licenses.
 * http://benalman.com/about/license/
 */

// Script: jQuery doTimeout: Like setTimeout, but better!
//
// *Version: 1.0, Last updated: 3/3/2010*
// 
// Project Home - http://benalman.com/projects/jquery-dotimeout-plugin/
// GitHub       - http://github.com/cowboy/jquery-dotimeout/
// Source       - http://github.com/cowboy/jquery-dotimeout/raw/master/jquery.ba-dotimeout.js
// (Minified)   - http://github.com/cowboy/jquery-dotimeout/raw/master/jquery.ba-dotimeout.min.js (1.0kb)
// 
// About: License
// 
// Copyright (c) 2010 "Cowboy" Ben Alman,
// Dual licensed under the MIT and GPL licenses.
// http://benalman.com/about/license/
// 
// About: Examples
// 
// These working examples, complete with fully commented code, illustrate a few
// ways in which this plugin can be used.
// 
// Debouncing      - http://benalman.com/code/projects/jquery-dotimeout/examples/debouncing/
// Delays, Polling - http://benalman.com/code/projects/jquery-dotimeout/examples/delay-poll/
// Hover Intent    - http://benalman.com/code/projects/jquery-dotimeout/examples/hoverintent/
// 
// About: Support and Testing
// 
// Information about what version or versions of jQuery this plugin has been
// tested with, what browsers it has been tested in, and where the unit tests
// reside (so you can test it yourself).
// 
// jQuery Versions - 1.3.2, 1.4.2
// Browsers Tested - Internet Explorer 6-8, Firefox 2-3.6, Safari 3-4, Chrome 4-5, Opera 9.6-10.1.
// Unit Tests      - http://benalman.com/code/projects/jquery-dotimeout/unit/
// 
// About: Release History
// 
// 1.0 - (3/3/2010) Callback can now be a string, in which case it will call
//       the appropriate $.method or $.fn.method, depending on where .doTimeout
//       was called. Callback must now return `true` (not just a truthy value)
//       to poll.
// 0.4 - (7/15/2009) Made the "id" argument optional, some other minor tweaks
// 0.3 - (6/25/2009) Initial release

!function(n){var t={},e="doTimeout",i=Array.prototype.slice;function f(e){var f,o=this,a={},c=e?n.fn:n,r=arguments,u=4,l=r[1],p=r[2],d=r[3];function y(){e?f.removeData(e):l&&delete t[l]}function $(){a.id=setTimeout(function(){a.fn()},p)}if("string"!=typeof l&&(u--,l=e=0,p=r[1],d=r[2]),e?(f=o.eq(0)).data(e,a=f.data(e)||{}):l&&(a=t[l]||(t[l]={})),a.id&&clearTimeout(a.id),delete a.id,d)a.fn=function(n){"string"==typeof d&&(d=c[d]),!0!==d.apply(o,i.call(r,u))||n?y():$()},$();else{if(a.fn)return void 0===p?y():a.fn(!1===p),!0;y()}}n[e]=function(){return f.apply(window,[0].concat(i.call(arguments)))},n.fn[e]=function(){var n=i.call(arguments),t=f.apply(this,[e+n[0]].concat(n));return"number"==typeof n[0]||"number"==typeof n[1]?this:t}}(jQuery);